module.exports = __webpack_public_path__ + "img/linggekj_login_img@3x.d798a879.png";